export default "__VITE_ASSET__BGkaDdBU__"